import { toObject } from "../../core/utils";
import moment from "moment";
import { isNil } from "lodash/fp";

class EventPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const mapEventField = (item) => {
      item.isDisabled = true;

      if (item.station && item.station.name) {
        item.name = item.station.name;
      }

      if (item.station && item.station._id) {
        item._id = item.station._id;
      }

      if (item.type) {
        item.isSelected = true;
      } else {
        item.isSelected = false;
      }

      return item;
    };

    data.output_date = moment(data.start_date).format("dddd D");
    if (!isNil(data.cities)) data.cities.map(mapEventField);
    if (!isNil(data.stations)) data.stations.map(mapEventField);
    return toObject(data);
  }
}

export default EventPageTransform;



// WEBPACK FOOTER //
// ./src/pages/event/event.transforms.js